import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fiscalFxSourceCandidatesSchema,
  fiscalFxSourceReviewPreviewSchema,
  fiscalFxSourceReviewSchema,
  type FiscalFxSourceReviewInput,
  type FiscalFxSourceReviewCreate,
} from '@erp/shared';
import { apiFetch } from '@/lib/api-client';
const path = '/api/v1/accounting/ledger/vat-source-reviews';
const key = ['fiscal-fx-source-reviews'] as const;
export function useFiscalSourceCandidates(page: number, q: string) {
  return useQuery({
    queryKey: [...key, page, q],
    queryFn: () =>
      apiFetch(
        `${path}?page=${page}&pageSize=25&q=${encodeURIComponent(q)}`,
        fiscalFxSourceCandidatesSchema,
      ),
  });
}
export function useFiscalSourcePreview() {
  return useMutation({
    mutationFn: (body: FiscalFxSourceReviewInput) =>
      apiFetch(`${path}/preview`, fiscalFxSourceReviewPreviewSchema, { method: 'POST', body }),
  });
}
export function useCreateFiscalSourceReview() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (body: FiscalFxSourceReviewCreate) =>
      apiFetch(path, fiscalFxSourceReviewSchema, { method: 'POST', body }),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: key });
      await client.invalidateQueries({ queryKey: ['ledger'] });
    },
  });
}
